var _ellipse, _path, _ellipse2, _path2, _ellipse3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallingGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44,
    cy: 44.001,
    rx: 44,
    ry: 44.001,
    fill: "#292929"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 44.001C87.5 68.0259 68.0244 87.502 44 87.502C19.9756 87.502 0.5 68.0259 0.5 44.001C0.5 19.976 19.9756 0.5 44 0.5C68.0244 0.5 87.5 19.976 87.5 44.001Z",
    stroke: "#00E13F",
    strokeOpacity: 0.16
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.0001,
    cy: 44.0019,
    rx: 35.4444,
    ry: 35.4452,
    fill: "#292929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9446 44.0019C78.9446 63.3016 63.2994 78.9471 44.0001 78.9471C24.7008 78.9471 9.05566 63.3016 9.05566 44.0019C9.05566 24.7021 24.7008 9.05664 44.0001 9.05664C63.2994 9.05664 78.9446 24.7021 78.9446 44.0019Z",
    stroke: "#00E13F",
    strokeOpacity: 0.41
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.9998,
    cy: 44.0004,
    rx: 28.1111,
    ry: 28.1117,
    fill: "#00E13F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3914_19739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0841 44.0454C39.7205 47.2613 42.3511 49.8919 45.5727 51.5283L48.0727 49.0226C48.3852 48.7101 48.834 48.6192 49.2261 48.7442C50.4988 49.1646 51.8681 49.3919 53.2829 49.3919C53.9135 49.3919 54.4192 49.8976 54.4192 50.5283V54.5055C54.4192 55.1362 53.9135 55.6419 53.2829 55.6419C42.6125 55.6419 33.9648 46.9942 33.9648 36.3239C33.9648 35.6932 34.4762 35.1875 35.1012 35.1875H39.0784C39.7091 35.1875 40.2148 35.6932 40.2148 36.3239C40.2148 37.7386 40.4421 39.1079 40.8625 40.3806C40.9875 40.7727 40.8966 41.2215 40.5841 41.534L38.0841 44.0454Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3914_19739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.2725,
    height: 27.2725,
    fill: "white",
    transform: "translate(30.5557 31.7783)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallingGreen);
export default __webpack_public_path__ + "static/media/calling_green.e305399b6237b74f7cd5b2c2ba31f09c.svg";
export { ForwardRef as ReactComponent };